import { NgModule } from '@angular/core';
import { S122gS122m01Component } from './s122g-s122m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S122gS122m01Component]
})
export class S122gModule { }

